import { AbstractControl, ValidationErrors } from '@angular/forms';

export function noWhitespace(control: AbstractControl) {
  const value = control.value;

  if (typeof value === 'string' && value.trim().length === 0) {
    return { required: true };
  }

  return null;
}